<template>
  <div class="organizations-container">
    <b-row align-v="start">
      <b-col cols="12" lg="12" md="12" sm="12" xs="12" class="mb-3" v-for="organization in organizations" :key="organization.id">
        <ul class="list-unstyled">
          <OrganizationMedia v-bind:organization="organization" v-bind:type="type"/>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import OrganizationMedia from './OrganizationMedia'

export default {
  name: 'OrganizationsList',
  components: {
    OrganizationMedia
  },
  props: {
    'organizations': Array,
    'type': String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationsList.vue